<template>
  <div class="xpage-top">
    <div class="xpage-top-left">
      <div class="name-container" style="display: flex; width: 100%">
        <div class="left" style="width: 112px">
          <div class="xpage-top-profile">
            <div class="xpage-top-profile-icon">
              {{ summary.primaryApplicantInitials }}
            </div>
          </div>
        </div>
        <div class="right" style="width: calc(100% - 112px - 22px)">
          <div id="name">
            <h2
              :title="summary.primaryApplicantFullName"
              class="applicant-name fullname-wrap text-overflow-ellipsis"
              style="display: block !important"
              v-title-overflow
            >
              {{ summary.primaryApplicantFullName || "No Name" }}
            </h2>
            <h3 :title="summary.lenderName" v-title-overflow>
              {{ summary.lenderName || "No Lender Provided" }}
            </h3>
          </div>
          <div
            v-if="applicationStore.isParentLOC"
            class="icon-student student-info"
            id="student"
          >
            <span>&nbsp;Student:</span
            ><span
              class="text-wrap-auto"
              :title="
                summary.studentFullName ? summary.studentFullName : undefined
              "
              v-title-overflow
            >
              &nbsp;{{ summary.studentFullName }}</span
            >
          </div>
          <PermissionsWrapper
            :showDisabledIfNotVisible="true"
            :permissionIds="[Permissions.ProgramConfiguration]"
            :permissionLevel="PermissionLevels.Update"
          >
            <application-status />
          </PermissionsWrapper>
          <div
            v-if="showMoveToLoanService"
            class="xpage-top-details-status"
            v-auto-animate="{ ...$animate, duration: 100 }"
          >
            <button
              type="submit"
              class="moveToLoanService-btn"
              @click="moveToLoanService(true)"
            >
              Move To Loan Service »
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="xcollapse-mobile">
      <a
        href="#"
        :class="toggleIconClass"
        @click.prevent="toggleApplicationDetailsMobile"
      ></a>
    </div>
    <div class="xpage-top-right" :class="{ xhideformobile: mobileHidden }">
      <div class="xpage-top-right-col">
        <h2>Line of Credit</h2>
        <h3>
          {{ LOCLimit }}
        </h3>
        <h4>
          Requested
          {{ summary.initialDrawAmount }}
        </h4>
      </div>
      <div class="xpage-top-right-col">
        <h2>Anticipated Graduation</h2>
        <div>
          <h3>
            {{ summary.graduationDate }}
          </h3>
          <h4>
            {{ applicationTab.school?.schoolName || "No School Provided" }}
          </h4>
        </div>
      </div>
      <div class="xpage-top-right-col">
        <h2>Interest Rate</h2>
        <div>
          <h3>
            {{ summary.rate }}
          </h3>
          <h4>
            {{ summary.rateTypeName }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed, ref } from "vue";
import { storeToRefs } from "pinia";
import ApplicationStatus from "@/components/v2/application/ApplicationStatus.vue";
import { Permissions, PermissionLevels } from "@/models/permissions";
import PermissionsWrapper from "../../../wrappers/PermissionsWrapper.vue";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { useApplicationDetails } from "@/composables/application/useApplicationDetails";
import functions from "@/use/functions";

const applicationStore = useApplicationStore();

const { summary, applicationTab } = storeToRefs(applicationStore);

const { moveToLoanService } = useApplicationDetails();

const mobileHidden = ref<boolean>(true);

const showMoveToLoanService = computed(() => {
  return (
    applicationStore.viewModel.statusName === "Complete" &&
    !applicationStore.viewModel.loanId
  );
});

const toggleIconClass = computed(() =>
  mobileHidden.value ? "icon-down-open-big" : "icon-up-open-big"
);

const LOCLimit = computed<string>(() => {
  return summary.value.loanAmount > 0 ? summary.value.loanAmountDisplay : "—";
});

const toggleApplicationDetailsMobile = () => {
  mobileHidden.value = !mobileHidden.value;
};

onMounted(() => {
  functions.getType("ApplicationStatus");
});
</script>

<style scoped>
.moveToLoanService-btn {
  background: #48a842;
  color: white;
  line-height: 26px;
  font-weight: 600;
  border: 0;
  padding: 0 12px;
  border-radius: 6px;
}

.moveToLoanService-btn:hover {
  background: #0ecb8e;
}

div.xpage-top-left {
  max-width: calc(100% / 2);
}

div.xpage-top-right {
  gap: 25px;
}

@media screen and (max-width: 1270px) {
  div.xpage-top-left {
    max-width: 100%;
  }

  div.xpage-top-right {
    gap: 25px;
    justify-content: space-around;
    max-width: 100%;
  }
  .xpage-top-right-col {
    text-wrap: auto;
    max-width: calc(100% / 3);
  }
}

@media screen and (max-width: 900px) {
  div.xpage-top-right {
    padding: 0;
  }
  .xpage-top-right-col {
    width: 100%;
    padding: 10px;
    max-width: 100%;
  }
}
</style>
<style scoped src="@/assets/css/application-details/student.css"></style>
